import { DailyMotion } from './DailyMotion.js';
import { Facebook } from './Facebook.js';
import { FilePlayer } from './FilePlayer.js';
import { Mixcloud } from './Mixcloud.js';
import { SoundCloud } from './SoundCloud.js';
import { Streamable } from './Streamable.js';
import { Twitch } from './Twitch.js';
import { Vimeo } from './Vimeo.js';
import { Wistia } from './Wistia.js';
import { YouTube } from './YouTube.js';
import 'react';
import '../singlePlayer.js';
import '../Player.js';
import '../props.js';
import 'prop-types';
import '../utils.js';
import 'lodash';

var players = [
  YouTube,
  SoundCloud,
  Vimeo,
  Facebook,
  Streamable,
  Wistia,
  Twitch,
  DailyMotion,
  Mixcloud,
  FilePlayer
];

export { players as default };
//# sourceMappingURL=index.js.map
